import React from 'react'  
import { App,} from 'antd'
import {useTDtijiaoMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon';
function ReportSubmit(props) {   
    const {message} = App.useApp()     
    // console.log(info);
    const [tijiao] = useTDtijiaoMutation();
    //批量删除
    const handleSubmit = (targetState) => {
        if(!props.dsbzd_name){
            message.error('团队名称不能为空！')
            return false;
        }
        if(!props.dsbzd_date){
            message.error('开始日期不能为空！')
            return false;
        }
        if(!props.dsbzd_date_end){
            message.error('结束日期不能为空！')
            return false;
        }
        if(!props.dsbzd_kh_id){
            message.error('客户不能为空！')
            return false;
        }
        if(!props.dsbzd_jd_id){
            message.error('计调不能为空！')
            return false;
        }
        if(!props.dsbzd_zb_id){
            message.error('销售不能为空！')
            return false;
        }
        if(!props.dsbzd_bm_id){
            message.error('部门不能为空！')
            return false;
        }
            
        
        tijiao({
            'dsbzd_id': props.dsbzd_id,
            'dsbzd_uid': props.dsbzd_uid,
            'dsbzd_uname': props.dsbzd_uname,
            'qy_id': props.qy_id,
            'qy_name': props.qy_name,
            'dsbzd_name': props.dsbzd_name,
            'dsbzd_date': props.dsbzd_date,
            'dsbzd_date_end': props.dsbzd_date_end,
            'dsbzd_kh_id': props.dsbzd_kh_id,
            'dsbzd_kh_name': props.dsbzd_kh_name,
            'dsbzd_spjd_user_id':props.dsbzd_uid,
            'dsbzd_spjd_bm_id': props.dsbzd_bm_id,
        }).then((res) => {
            if(res.data.Status === 'success') {
                message.success('团队报账单提交成功！')
            }else{
                message.error('团队报账单提交失败！'+res.data.Message)
            }
        })
        
    }
   
    return (
        <Icon type='submit' onClick={() => {handleSubmit();}}/>    
    )
}

export default ReportSubmit